import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError, apiRequest } from './client';
import { ticketsQueryKey } from './tickets';

/**
 * `DELETE /tickets/:code/reply-draft`: «Scarta» la bozza di risposta del ticket (DEC-015 decisione 7,
 * #158). Risponde 204 anche se la bozza non c'è più; dopo, il dettaglio si rilegge e la bozza sparisce
 * da sopra il composer (#159).
 */
export function useDiscardReplyDraft(code: string) {
  const queryClient = useQueryClient();
  return useMutation<void, ApiError, void>({
    mutationFn: () => apiRequest<void>(`/tickets/${encodeURIComponent(code)}/reply-draft`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ticketsQueryKey }),
  });
}
